import { Camera } from '@capacitor/camera';
import { Geolocation } from '@capacitor/geolocation';
import { PushNotifications } from '@capacitor/push-notifications';
import { isNativeMobileApp } from './platform';

export async function ensureGeolocationPermission() {
  if (!isNativeMobileApp()) return { location: 'granted' };
  return Geolocation.requestPermissions();
}

export async function ensureCameraPermission() {
  if (!isNativeMobileApp()) return { camera: 'granted', photos: 'granted' };
  return Camera.requestPermissions();
}

export async function ensurePushPermission() {
  if (!isNativeMobileApp()) return { receive: 'granted' };

  const status = await PushNotifications.checkPermissions();
  if (status.receive === 'granted') return status;
  return PushNotifications.requestPermissions();
}
